import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CSCombine() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px]" data-id="element-569">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-8" data-id="element-570">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-571">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-10 font-[600] font-[Poppins,_sans-serif]" data-id="element-572">
            COMBINE WITH THESE TREATMENTS
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 w-full mb-10" data-id="element-573">
            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-574">
              <h3 className="text-black text-xl font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-575">
                SkinTyte
              </h3>
              <p className="text-[#333333] text-sm leading-[1.6] font-body" data-id="element-576">
                SkinTyte utilizes broadband light technology (BBL) that deeply
                heats the deep layers of the skin, while cooling the surface
                layer. The process initiates the body's natural healing process
                to create a new collagen foundation. The fresh collagen makes
                the skin appear tight, plump and youthful for up to 12 months.
              </p>
            </div>

            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-577">
              <h3 className="text-black text-xl font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-578">
                Clear + Brilliant
              </h3>
              <p className="text-[#333333] text-sm leading-[1.6] font-body" data-id="element-579">
                For smoother, brighter and dewy skin without downtime for
                recovery, Clear + Brilliant Touch is an innovative laser
                treatment that can rejuvenate your skin with precision and care.
                By harnessing the power of fractional laser technology, it
                effectively targets early signs of aging, sun damage and uneven
                skin texture.
              </p>
            </div>

            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-580">
              <h3 className="text-black text-xl font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-581">
                HALO Laser Resurfacing
              </h3>
              <p className="text-[#333333] text-sm leading-[1.6] font-body" data-id="element-582">
                At Be CLINICAL we're pleased to offer Halo Skin Resurfacing
                Laser, a comprehensive approach to skin rejuvenation, addressing
                both superficial and deeper skin concerns simultaneously. It
                uses a unique hybrid technology which is unmatched, giving you a
                deeper level of collagen and elastin stimulation.
              </p>
            </div>
          </div>

          <p className="font-serif italic text-white text-2xl lg:text-[28px]" data-id="element-583">
            Treat yourself!
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}